import { Injectable } from '@angular/core';
import { CommonUtils } from '../../js/static/CommonUtils';
import { AmorphicService } from '../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { CommonControllerInterface } from '../../../coverpath-common/angular/interfaces/controller/CommonControllerInterface';
import piiConfig from '../../../../config_pii_properties.json';
import { ObfuscationProperty } from '../../js/interfaces/CommonTypes';

@Injectable()
export class PiiService {
  private controller: CommonControllerInterface;
  private piiPropertiesToDataElementMap: Map<string, string>;

  constructor(private amorphicService: AmorphicService) {
    this.controller = amorphicService.controller;
    this.loadConfig();
  }

  /* Check if an object property is defined as a PII property.
   */
  isPiiProperty(prop: string): boolean {
    if (!prop) {
      return false;
    }

    /* Temp workaround to only allow driver's licenses to be saved as pii keys.
    Remove this code once all id types (passport, state ID) are supported. */
    if (
      prop.includes('idNumber') &&
      this.controller.customer.application.primaryPolicy.insured.person.idType !== 'drivers'
    ) {
      return false;
    }

    return this.piiPropertiesToDataElementMap.has(CommonUtils.convertToGenericProp(prop));
  }

  /*
  Return the data element for a given PII property.
  E.g., for property 'insured.person.SSN', returns data element 'SSN'
   */
  getPiiDataElement(prop: string): string {
    if (!prop) {
      return undefined;
    }

    return this.piiPropertiesToDataElementMap.get(CommonUtils.convertToGenericProp(prop));
  }

  async setPiiByProperty(prop: string, value: string): Promise<string> {
    return this.controller.setPiiByProperty(prop, value);
  }

  async getPiiValueByKey(key: string, obfuscationProperty: ObfuscationProperty): Promise<string> {
    return this.controller.getPiiValueByKey(
      key,
      0,
      this.includeHyphens(obfuscationProperty.type),
      obfuscationProperty.type
    );
  }

  includeHyphens(dataElement: string): boolean {
    switch (dataElement) {
      case 'SSN':
        return true;
      default:
        return false;
    }
  }

  loadConfig(): void {
    /*
    If already loaded, simply return because we load config only once.
     */
    if (this.piiPropertiesToDataElementMap) {
      return;
    }

    this.piiPropertiesToDataElementMap = CommonUtils.extractPiiConfigForApplication(piiConfig.dataElements);
  }
}
